import DF from '@rover/shared/js/constants/i18n/datetime';
import StaticStickitView from './static_stickit_view';

export default StaticStickitView.extend({
  // A view for selecting the date range.  The view takes a Query as its
  // model, and the date input boxes are bound to its 'start_date' and
  // 'end_date' attributes
  bindings: {
    ':el': {
      observe: 'service_type',
      visible(val, options) {
        const serviceType = _.findWhere(Rover.serviceTypesJson, { slug: val });
        return !serviceType || !serviceType.supports_day_of_week_search;
      },
    },
    '.js-start-date': {
      observe: 'start_date',
      attributes: [
        {
          name: 'placeholder',
          observe: 'start_text',
        },
      ],
    },
    '.js-end-date': {
      observe: 'end_date',
      attributes: [
        {
          name: 'placeholder',
          observe: 'end_text',
        },
      ],
    },
    '.js-xs-start-date-placeholder': 'start_text',
    '.js-xs-end-date-placeholder': 'end_text',
  },

  constructor(options) {
    this.query = options.query;
    this.model = new Rover.models.DateRange({
      start_date: this.query.get('start_date'),
      end_date: this.query.get('end_date'),
      service_type: this.query.get('service_type'),
    });
    this.setPlaceholderText();
    StaticStickitView.prototype.constructor.call(this, options);
  },

  initialize(options) {
    this.options = _.extend({}, this.defaults, options);

    this.$el.daterangepicker({
      startElementSelector: this.$('.js-start-date'),
      endElementSelector: this.$('.js-end-date'),
      dateFormat: DF.DATE_PICKER,
    });

    this.$('.js-start-date').on('closed.datepicker', _.bind(this.onDatepickerClosed, this));
    this.$('.js-end-date').on('closed.datepicker', _.bind(this.onDatepickerClosed, this));

    // Watch the query object for changes
    this.query.on('change:start_date', _.bind(this.onQueryFromdateChanged, this));
    this.query.on('change:end_date', _.bind(this.onQueryTodateChanged, this));
    this.query.on('change:service_type', _.bind(this.setPlaceholderText, this));

    // Initialize stickit
    StaticStickitView.prototype.initialize.call(this);
  },

  onQueryFromdateChanged() {
    this.model.set('start_date', this.query.get('start_date'));
  },

  onQueryTodateChanged() {
    this.model.set('end_date', this.query.get('end_date'));
  },

  onDatepickerClosed() {
    _.delay(() => {
      const $datepicker = $('#ui-datepicker-div');
      const bothFieldsSet = this.model.get('start_date') && this.model.get('end_date');
      const visible = $datepicker.is(':visible');

      if (bothFieldsSet && !visible) {
        this.query.set(this.model.toJSON());
        this.trigger('queryUpdated');
      }
    }, 250);
  },

  getPlaceholderText() {
    const serviceType = this.query.get('service_type');

    if (serviceType === 'overnight-boarding') {
      return {
        start_text: 'Drop off',
        end_text: 'Pick up',
      };
    }

    return {
      start_text: 'Start date',
      end_text: 'End date',
    };
  },

  setPlaceholderText() {
    this.model.set(this.getPlaceholderText());
    this.model.set('service_type', this.query.get('service_type'));
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/date_picker_view.js